module.exports = __webpack_public_path__ + "img/1sb_serta_with_sheep_logo_desk_v3.7896627.svg";